import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import {useCurrentlySticky} from "../utils/FilterHooks";
import FilterField from "./FilterField";

function AccountFilterField(props) {
	const [stickyFilter, setStickyFilter] = useState(false);
	const authenticatedUser = useContext(AuthorizedUserContext);
	const currentlySticky = useCurrentlySticky(authenticatedUser, AccountFilterField.stickyLocalStorageKey);

	let {accountOptions, changeHandler, stickyFilterHandler, includeReset, className} = props;

	useEffect(() => {
		if (AuthorizedUser.hasStickyAccountFilter(authenticatedUser)) {
			setStickyFilter(true);
		}
	}, [authenticatedUser, setStickyFilter]);

	return accountOptions && accountOptions.length > 1 ?
		<FilterField
			includeSelectAll
			includeReset={includeReset}
			options={accountOptions}
			name="account"
			menuTitle="Accounts"
			selectAllTitle="All Accounts"
			className={className}
			changeHandler={changeHandler}
			allowSticky={stickyFilter}
			currentlySticky={currentlySticky}
			stickyFilterHandler={stickyFilterHandler}
			stickyLocalStorageKey={AccountFilterField.stickyLocalStorageKey} /> : null;
}

AccountFilterField.propTypes = {
	changeHandler: PropTypes.func.isRequired,
	stickyFilterHandler: PropTypes.func,
	accountOptions: PropTypes.array,
	includeReset: PropTypes.bool,
	className: PropTypes.string
};

AccountFilterField.stickyLocalStorageKey = 'account-filter-select';

export default AccountFilterField;